import React from 'react';

import { Format } from '@/domain/app';
import { CreditCardService } from '@/domain/card';

import { Card, CreditCard } from '@generated-types';
import useText from '@hooks/use-text';

interface CardInformationProps {
    card: Card | CreditCard;
}

export const CardInformation = ({ card }: CardInformationProps) => {
    const { overviewDetailsCardNumber } = useText();

    const isCreditCard = CreditCardService.isCreditCard(card);

    const cardNumber = Format.cardNumber(isCreditCard ? card.cardNumber : card.number);

    return (
        <div className="google-pay-activation-form-content__card-information">
            <p>{`${overviewDetailsCardNumber} ${cardNumber}`}</p>
        </div>
    );
};
